import apiClient from '@/api/client';

class BasicResource {
    constructor (resourceName) {
        this.resourceName = resourceName;
        this.client = apiClient;
    }

    list (params) {
        return this.client.request({
            method: 'get',
            path: `/publisher/v1/${this.resourceName}`,
            params: params,
        });
    }

    get (id) {
        return this.client.request({
            method: 'get',
            path: `/publisher/v1/${this.resourceName}/${id}`,
        });
    }

    create (data) {
        return this.client.request({
            method: 'post',
            path: `/publisher/v1/${this.resourceName}`,
            data: data,
        });
    }

    delete (id) {
        return this.client.request({
            method: 'delete',
            path: `/publisher/v1/${this.resourceName}/${id}`,
        });
    }

    retrieve (id) {
        return this.client.request({
            method: 'get',
            path: `/publisher/v1/${this.resourceName}/${id}/retrieve`,
        });
    }

    update (id, data) {
        return this.client.request({
            method: 'put',
            path: `/publisher/v1/${this.resourceName}/${id}`,
            data: data,
        });
    }
}

export default BasicResource;

